export default "__VITE_ASSET__Dvhq_xl6__"